import Vue from 'vue'
import Vuex from 'vuex'
import Account from './modules/account'
import StaffList from './modules/staff-list'
import Report from './modules/report'
import ShopList from './modules/shop-list'
import QualityAssuranceAdd from './modules/qualityAssuranceAdd'
import QualityAssuranceQuery from './modules/qualityAssuranceQuery'
import QualityAssuranceRecordList from './modules/qualityAssuranceList'
import Employer from './modules/employer';
import Announcement from './modules/announcement'
import Area from './modules/area'
import OrderDetail from './modules/orderdetail';
import OrderList from './modules/orderlist'
import Trouble from './modules/trouble'
import OrderReceiveMoney from './modules/orderReceiveMoney';
import Loading from './modules/loading';
import Recycle from './modules/recycle';
import ServicesCodeOrder from './modules/servicescodeorder';
import OrderFill from './modules/orderfill';
import SetOrder from './modules/setorder';
import RepairSmallTicket from './modules/repairSmallTicket';
import StoreAdd from './modules/storeadd';
import AgentrepairOrderDetail from './modules/agentrepairOrderDetail';
import RepaireCheck from './modules/repairCheck';
import App from './modules/app';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        Account,
        StaffList,
        Report,
        ShopList,
        QualityAssuranceAdd,
        QualityAssuranceQuery,
        QualityAssuranceRecordList,
        Employer,
        Announcement,
        Area,
        OrderDetail,
        OrderList,
        Trouble,
        OrderReceiveMoney,
        Loading,
        Recycle,
        ServicesCodeOrder,
        SetOrder,
        OrderFill,
        RepairSmallTicket,
        StoreAdd,
        AgentrepairOrderDetail,
        RepaireCheck,
        App
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js